<template>
  <ul class="question-options list-group">
    <li class="list-group-item border-0"
        v-for="item in items"
        v-bind:class="{ active: selection.indexOf(item) > -1 }"
        @click="select(item)" v-html="item.key + '. ' + item.text"></li>
  </ul>
</template>

<script>
  export default {

    name: 'Options',

    props: {
      items: {
        type: Array,
        required: true,
        default: () => {
          return []
        }
      },

      selected: {
        type: Array,
        required: false,
        default: () => {
          return []
        }
      },

      isMultiple: {
        type: Boolean,
        required: false,
        default: false
      }
    },

    data () {
      return {
        options: ['A', 'B', 'C', 'D'],
        selection: []
      }
    },

    created () {
      this.selection = this.selected
    },

    methods: {
      select (option) {
        var isSelected = this.selection.indexOf(option)

        if (!this.isMultiple) {
          this.selection.splice(0, this.selection.length)
        }

        if (isSelected > -1) {
          this.selection.splice(isSelected, 1)
        } else {
          this.selection.push(option)
        }

        this.$emit('answer', {
          id: '',
          answers: this.selection
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/style/color.scss";

  .question-options {
    li {
      cursor: pointer;

      &.active {
        color: white;
        background-color: $normal
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Options.vue?5013f029